import { Schema } from '../../types'
import { commonColumns } from '../common_schema'

export const scaleInoutSchema: Schema = {
  title: 'On-going Scale In/Out',
  level: 2,
  columns: commonColumns
}
